// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___2XUUI","open":"open___24w9z","syncTitle":"syncTitle___etJPe","rightIcon":"rightIcon___1KVfK"};